import { redirect } from 'saddlebag-browser';

import BpkSnippet from '@skyscanner/backpack-web/bpk-component-snippet';

import CardRail from '../CardRail';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { PackagesPopularDestinationsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/PackagesPopularDestinationsProps';

import STYLES from './PackagesPopularDestinations.module.scss';

const PackagesPopularDestinations = ({
  cards,
  ctaText,
  isSmallScreen,
  subtitle,
  title,
}: PackagesPopularDestinationsProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  if (!cards || cards.length <= 0 || !title || !ctaText) {
    return null;
  }
  const handleClick = (redirectUrl: string) => {
    redirect(redirectUrl);
  };

  return (
    <div
      className={STYLES.PackagesPopularDestinations}
      data-testid="packages-popular-destinations"
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <CardRail
        title={title}
        subtitle={subtitle}
        bottomNav={!isSmallScreen}
        scrollableOnTablet
      >
        {cards.map((card, index) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
          <div
            key={`image_snippet_${card.headline}`}
            className={STYLES.PackagesPopularDestinations__ImageSnippet}
            onClick={() => handleClick(card.redirectUrl)}
            data-testid={`packages-popular-destinations-${index}`}
            data-tracking-element-id={`${rawComponentName}_item_${index}`}
            data-tracking-common-params={buildMBDParam(
              `${rawComponentName}_item`,
              {
                destination_name: card.headline,
              },
            )}
          >
            <BpkSnippet
              {...card}
              desktopLayout="vertical"
              headlineStyle="heading-3"
              onClick={() => handleClick(card.redirectUrl)}
              buttonText={ctaText}
              imageOrientation={isSmallScreen ? 'square' : 'portrait'}
            />
          </div>
        ))}
      </CardRail>
    </div>
  );
};

export default PackagesPopularDestinations;
